import { FormattedMessage, injectIntl, InjectedIntlProps } from 'react-intl';

import errorImageSvg from 'src/components/error-boundary/global-error-image.svg';

import messages from './error-state.i18n';
import * as styles from './error-state.styled';

export type ErrorStateProps = {
  message: FormattedMessage.MessageDescriptor;
  onRetry: () => void;
};

export const ErrorState = injectIntl(
  ({ intl, message, onRetry }: ErrorStateProps & InjectedIntlProps) => {
    return (
      <styles.Container>
        <styles.Image src={errorImageSvg} />
        <h3>
          <FormattedMessage {...message} />
        </h3>
        <styles.Details>
          <FormattedMessage {...messages.tryAgainMessage} />
        </styles.Details>
        <styles.RetryButton appearance="link" onClick={onRetry}>
          {intl.formatMessage(messages.retryButtonLabel)}
        </styles.RetryButton>
      </styles.Container>
    );
  }
);
